if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      // Defer initial scroll/height calculation to after first paint (reduces forced reflows)
      requestAnimationFrame(function() { window.dispatchEvent(new Event('scroll')); });

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight.bind(this), {
          passive: true
        });
        requestAnimationFrame(this.setAnnouncementHeight.bind(this));
        requestAnimationFrame(function() { window.dispatchEvent(new Event('resize')); });
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let h = this.getBoundingClientRect().top;
        if (h <= 0) {
          this.classList.add('is-sticky');
        } else {
          this.classList.remove('is-sticky');
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) {
        detailsElement.classList.remove('submenu-open');
      } else {
        detailsElement.classList.add('submenu-open');
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('submenu-open');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener('resize', debounce(function () {
          _this.resizeSubMenus();
        }, 100));
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}

// RK Nav Arrow Fix - Inject CSS to remove the misplaced dropdown arrow indicator
// The ::after pseudo-element on .thb-full-menu li.menu-item-has-children > a
// creates a small triangle arrow that appears to the LEFT of the nav link text.
(function() {
  var style = document.createElement('style');
  style.id = 'rk-nav-arrow-fix';
  style.textContent = '.thb-full-menu li.menu-item-has-children > a::after { display: none !important; } .thb-full-menu > li.menu-item-has-children > a { padding-right: 0 !important; }';
  document.head.appendChild(style);
})();


// ===== RK MEGA-MENU HOVER FIX =====
// Replaces CSS-only hover with JS delayed close so users can click dropdown items
(function() {
  function initMegaMenu() {
    var items = document.querySelectorAll('.menu-item-has-megamenu');
    if (!items.length) return;
    
    items.forEach(function(item) {
      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        // Close all other open menus
        items.forEach(function(other) {
          if (other !== item) other.classList.remove('rk-mega-open');
        });
        item.classList.add('rk-mega-open');
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function() {
          item.classList.remove('rk-mega-open');
        }, 300);
      }

      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);

      var dropdown = item.querySelector('.rk-mega-menu');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
        dropdown.addEventListener('mouseleave', scheduleClose);
      }

      item.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') item.classList.remove('rk-mega-open');
      });
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.menu-item-has-megamenu')) {
        items.forEach(function(i) { i.classList.remove('rk-mega-open'); });
      }
    });

    // Inject CSS: use rk-mega-open class to show dropdown instead of :hover
    if (!document.getElementById('rk-mega-open-css')) {
      var style = document.createElement('style');
      style.id = 'rk-mega-open-css';
      style.textContent = [
        '.menu-item-has-megamenu .rk-mega-menu { display: none; opacity: 0; transition: opacity 0.15s ease; pointer-events: none; }',
        '.menu-item-has-megamenu.rk-mega-open .rk-mega-menu { display: block; opacity: 1; pointer-events: auto; }',
        '.menu-item-has-megamenu:hover .rk-mega-menu { display: none; }',
        '.menu-item-has-megamenu.rk-mega-open .rk-mega-menu { display: block !important; }'
      ].join(' ');
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
  // Also run after a short delay to handle Shopify's deferred rendering
  setTimeout(initMegaMenu, 500);
})();
